// Two small copy buttons next to an endpoint (3.1 and the API catalogue): its UAT address and its production address.
import { useState } from 'react'
import { Check, Copy } from 'lucide-react'
import { useSettingsStore } from '@/store/settingsStore'
import { endpointUrl, type HubEnv } from '@/lib/urls'

export function CopyIcon({ text, label, disabled, title }: { text: string; label: string; disabled?: boolean; title?: string }) {
  const [done, setDone] = useState(false)
  return (
    <button
      type="button"
      className="inline-flex items-center gap-0.5 rounded px-1 py-0.5 text-[10px] font-semibold text-muted hover:bg-slate-200/70 hover:text-default disabled:cursor-not-allowed disabled:opacity-40 dark:hover:bg-slate-800"
      disabled={disabled}
      title={title ?? text}
      aria-label={`Copy ${label}`}
      onClick={async () => {
        try {
          await navigator.clipboard.writeText(text)
          setDone(true)
          setTimeout(() => setDone(false), 1500)
        } catch {
          setDone(false)
        }
      }}
    >
      {done ? <Check size={11} className="text-emerald-600" /> : <Copy size={11} />} {label}
    </button>
  )
}

/** UAT / production copy buttons for one route of a lender; production is off until the lender has a live batch. */
export function UrlCopy({ slug, route, live }: { slug: string; route: string; live: boolean }) {
  const urls = useSettingsStore((s) => s.settings.hubUrls)
  const of = (env: HubEnv) => endpointUrl(urls[env], slug, route)
  return (
    <span className="ml-1 inline-flex items-center gap-0.5 align-middle" data-testid={`url-copy-${route}`}>
      <CopyIcon text={of('uat')} label="UAT" />
      <CopyIcon text={of('production')} label="prod" disabled={!live} title={live ? of('production') : 'No live batch yet: the production address answers 404 until Make live'} />
    </span>
  )
}
